import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Sidebar as ProSidebar,
  Menu,
  MenuItem,
  useProSidebar,
  SubMenu,
} from 'react-pro-sidebar';
import { FaCalculator } from 'react-icons/fa';
import { IconType } from 'react-icons';

interface UtilityItem {
  id: string;
  name: string;
  path: string;
  icon: IconType;
}

interface UtilityCategory {
  id: string;
  name: string;
  icon: IconType;
  items: UtilityItem[];
}

interface SidebarProps {
  categories: UtilityCategory[];
}

const Sidebar: React.FC<SidebarProps> = ({ categories }) => {
  const { collapseSidebar, toggleSidebar, collapsed } = useProSidebar();
  const [toggled, setToggled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleToggle = () => {
    setToggled(!toggled);
    collapseSidebar();
  };

  const handleItemClick = (path: string) => {
    navigate(path);
  };

  const renderIcon = (icon: IconType | undefined) => {
    if (!icon) return CalculatorIcon;
    const IconComponent = icon
    // @ts-ignore
    return <IconComponent size={20} />;
  };

  const CalculatorIcon = () => (
    // @ts-ignore
    <FaCalculator size={20}/>
  );

  const MenuIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
    </svg>
  );

  const CloseIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
    </svg>
  );

  return (
    <div className="flex h-screen">
      <ProSidebar
        collapsed={collapsed}
        toggled={toggled}
        breakPoint="sm"
        className="h-screen border-r border-gray-200 bg-white"
        defaultCollapsed={true}
        width="250px"
        collapsedWidth="80px"
        backgroundColor="white"
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-white">
          {!collapsed && <h2 className="text-xl font-semibold text-gray-900">Davinqi</h2>}
          <button
            onClick={handleToggle}
            className="p-2 rounded-md hover:bg-gray-100 text-gray-600"
          >
            {collapsed ? <MenuIcon /> : <CloseIcon />}
          </button>
        </div>
        <Menu className="text-gray-700 bg-white">
          <MenuItem
            onClick={() => handleItemClick('/')}
            className={`${location.pathname === '/' ? 'bg-blue-50' : 'hover:bg-gray-100'}`}
          >
            Home
          </MenuItem>
          
          {categories.map((category) => (
            <SubMenu
              key={category.id}
              label={category.name}
              //@ts-ignore
              icon={<category.icon />}
              className="text-gray-700"
            >
              {category.items.map((item) => (
                <MenuItem
                  key={item.id}
                  onClick={() => handleItemClick(item.path)}
                  //@ts-ignore
                  icon={<item.icon />}
                  className={`${location.pathname === item.path ? 'bg-blue-50' : 'hover:bg-gray-100'}`}
                >
                  {item.name}
                </MenuItem>
              ))}
            </SubMenu>
          ))}
        </Menu>
      </ProSidebar>
    </div>
  );
};

export default Sidebar; 